<template>
<main class="situation">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('profile.situation_title') }}</h1>

  <!-- Container -->
  <section class="container" v-show="isLoading">
    <div class="profile-progress-circle">
      <progressbar v-if="level && (Progress!=null)" :level="level" :progress="Progress" :sectionlist="sectionData"></progressbar> 
    </div>
    <div class="flex-center">
    
      <div class="row">
      <template v-if="sectionList && sectionList.length">
        <ul class="situation-list">
          <li class="box" v-for="(section, section_idx) in sectionList" :key="section_idx" @click="selectSection(section)">
            <div class="title">{{ sectionTitle(section.section_id) }}</div>
            <div class="situation-data">
              <div class="situation-level">{{ section.level }}</div>
              <div class="situation-status" :class="section.status"></div>
              <div class="situation-progress">
                <div class="progress-label">
                  <div class="label-correct">{{ $t('profile.correct_rate') }}</div>
                  <div class="correct-rate">{{ section.rate  }}%</div>
                </div>
                <div class="progress-bar">
                  <div class="progress-rate" :style="{ width: section.rate + '%' }"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="box" v-show="!isLoading"></div>
      </template>
      </div>
    </div>
  </section>
</main>
</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'
  
  import ProgressBar from '../shared/ProgressBar.vue'

  export default {
    components: {
      'progressbar': ProgressBar,
    },
    props: {
      level: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        loading: false,
        section_all: [],
        section_list: [],
        learning_total: {},
        progress_rate: 0,
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      isLoading () {
        return this.loading
      },
      sectionList() {
         return this.section_list
      },
      Progress() {
        return this.progress_rate;
      },
      sectionData() {
        return this.$store.getters.section;
      },
    },
    
    created() {
      const self = this
      
      self.loading = false
      
      
      axios.get(api.section + '?level=' + this.level.toLowerCase())
      .then(function(resp) {
        self.section_all = resp.data.section;
        
        
        self.learning_total = self.$store.getters.learning_total
        let sectionKeys = Object.keys(self.section_all)
        for(let key of sectionKeys) {
          let sectionData = self.section_all[key]
          
          if(self.level == "N4") {
            if(sectionData.level != "N4" && sectionData.level != "N5") {
              continue;
            }
          } else if(sectionData.level != self.level) {
            continue;
          }
          
          let questionAll = self.learning_total.question_section_all.filter(item => {
              return (item.section_id == sectionData.section_id)
          })
          let correct_count = 0;
          let answer_count = 0;
          
          for(let questionData of questionAll) {
            correct_count += questionData.correct_count;
            answer_count += questionData.answer_count;
          }
          
          let rate = 0;
          if(correct_count && answer_count) {
            rate = Math.round((correct_count / answer_count) * 100);
          }
          self.section_list.push({
            ...sectionData,
            rate: rate
          })

        }
        
        
        
        
        self.$store.dispatch("showLoading", false);
      })
      .catch(err => {
        self.$store.dispatch("showLoading", false);
      });
      
      axios.get(api.progress + '?level=' + this.level)
      .then(function(resp) {
        self.progress_rate = resp.data.progress_rate;
        
      });
      
      
      
      this.loading = true
      
    },

    mounted() {
      
      const self = this
      
      self.loading = true
    },
    methods: {
      sectionTitle(section_id) {
        let sessionName = 'Session'
        if(section_id == 1) {
          sessionName = sessionName + ' 1-10'
        } else if(section_id == 2) {
          sessionName = sessionName + ' 11-20'
        } else if(section_id == 3) {
          sessionName = sessionName + ' 21-30'
        } else if(section_id == 4) {
          sessionName = sessionName + ' 31-40'
        } else if(section_id == 5) {
          sessionName = sessionName + ' 41-50'
        } else if(section_id == 6) {
          sessionName = sessionName + ' 51-60'
        } else if(section_id == 7) {
          sessionName = sessionName + ' 61-70'
        } else if(section_id == 8) {
          sessionName = sessionName + ' 71-80'
        } else if(section_id == 9) {
          sessionName = sessionName + ' 81-90'
        } else if(section_id == 10) {
          sessionName = 'N3 ' + sessionName + ' 1-3'
        } else if(section_id == 11) {
          sessionName = 'N3 ' + sessionName + ' 4-6'
        } else if(section_id == 12) {
          sessionName = 'N3 ' + sessionName + ' 7-9'
        } else if(section_id == 13) {
          sessionName = 'N3 ' + sessionName + ' 10-12'
        } else if(section_id == 14) {
          sessionName = 'N3 ' + sessionName + ' 13-15'
        } else if(section_id == 15) {
          sessionName = 'N3 ' + sessionName + ' 16-18'
        } else if(section_id == 16) {
          sessionName = 'N3 ' + sessionName + ' 19-21'
        } else if(section_id == 17) {
          sessionName = 'N3 ' + sessionName + ' 22-24'
        } else if(section_id == 18) {
          sessionName = 'N3 ' + sessionName + ' 25-27'
        } else if(section_id == 19) {
          sessionName = 'N3 ' + sessionName + ' 28-30'
        } else if(section_id == 20) {
          sessionName = 'N3 ' + sessionName + ' 31-33'
        } else if(section_id == 21) {
          sessionName = 'N3 ' + sessionName + ' 34-36'
        } else if(section_id == 22) {
          sessionName = 'N3 ' + sessionName + ' 37-39'
        } else if(section_id == 23) {
          sessionName = 'N3 ' + sessionName + ' 40-42'
        } else if(section_id == 24) {
          sessionName = 'N3 ' + sessionName + ' 43-45'
          
        } else if(section_id == 25) {
          sessionName = 'N2 ' + sessionName + ' 1-4'
        } else if(section_id == 26) {
          sessionName = 'N2 ' + sessionName + ' 5-8'
        } else if(section_id == 27) {
          sessionName = 'N2 ' + sessionName + ' 9-12'
        } else if(section_id == 28) {
          sessionName = 'N2 ' + sessionName + ' 13-16'
        } else if(section_id == 29) {
          sessionName = 'N2 ' + sessionName + ' 17-20'
        } else if(section_id == 30) {
          sessionName = 'N2 ' + sessionName + ' 21-24'
        } else if(section_id == 31) {
          sessionName = 'N2 ' + sessionName + ' 25-28'
        } else if(section_id == 32) {
          sessionName = 'N2 ' + sessionName + ' 29-32'
        } else if(section_id == 33) {
          sessionName = 'N2 ' + sessionName + ' 33-36'
        } else if(section_id == 34) {
          sessionName = 'N2 ' + sessionName + ' 37-40'
        } else if(section_id == 35) {
          sessionName = 'N2 ' + sessionName + ' 41-44'
        } else if(section_id == 36) {
          sessionName = 'N2 ' + sessionName + ' 45-48'
        } else if(section_id == 37) {
          sessionName = 'N2 ' + sessionName + ' 49-52'
        } else if(section_id == 38) {
          sessionName = 'N2 ' + sessionName + ' 53-56'
        } else if(section_id == 39) {
          sessionName = 'N2 ' + sessionName + ' 57-60'
        }
        return sessionName
      },
      selectSection(section) {
        // sectionを選択したと同等にする。
        this.$store.dispatch("setSectionData", section);
        
        if(this.level == "N4" || this.level == "N5") {
          if(section.status != 'incomplete') {
            this.$router.push({name: 'profile.situation.detail', params: { category: section.section, level: this.level }})
          }
        } else {
          this.$router.push({name: 'profile.situation.detail', params: { category: section.section, level: this.level }})
        }
      },
      back() {
        this.$router.push({name: 'profile'})
      }
    },

  }
</script>
